export enum EnumKnowledgeIngestionStage {
  Validate = 'validate',
  Extract = 'extract',
  Ocr = 'ocr',
  Normalize = 'normalize',
  Chunk = 'chunk',
  Embed = 'embed',
  Index = 'index',
  Cleanup = 'cleanup',
  /** Etapa não reconhecida: fica sem rótulo em vez de quebrar a tela. */
  Unknown = 'unknown'
}
